import * as api from '../../services/subAccounts'
import lodash from 'lodash'

export const FETCH_SUBACCOUNTEVENTSAPPLYS= 'FETCH_SUBACCOUNTEVENTSAPPLYS';




export const fetchSubAccountEventsApplys = (params, pagination, sort, extra) => {

    return {
        type: FETCH_SUBACCOUNTEVENTSAPPLYS,
        payload: {
            promise: api.findSubAccountEventsApplys(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: lodash.omit(params, 'isSub'),
            sort: sort,
            extra: extra
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/subAccount.js